// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--53735";
export var copyrightBox = "Footer-module--copyright-box--a2ead";
export var footer = "Footer-module--footer--f12b4";
export var footerBox = "Footer-module--footer-box--4402f";
export var footerLogo = "Footer-module--footer-logo--2df83";
export var footerLower = "Footer-module--footer-lower--0f07c";
export var footerMiddle = "Footer-module--footer-middle--8c06e";
export var footerNav = "Footer-module--footer-nav--fc29a";
export var footerNavList = "Footer-module--footer-nav-list--214de";
export var footerSocialLinksContainer = "Footer-module--footer-social-links-container--83025";
export var footerUpper = "Footer-module--footer-upper--0d185";
export var footerUpperLeft = "Footer-module--footer-upper-left--23546";
export var footerUpperRight = "Footer-module--footer-upper-right--b3a44";
export var mobSocialBox = "Footer-module--mob-social-box--d14eb";
export var socialLinks = "Footer-module--social-links--550ee";